export default __webpack_public_path__ + "static/media/26.35320567.png";